const AromataseContent = () => {
    return (
        <>
            <h4>
                A new class of drugs called aromatase inhibitors are introduced
            </h4>
            <p>
            A new class of drugs called aromatase inhibitors, such as anastrozole (Arimidex) in the ATAC trial and subsequently letrozole (Femara) in the BIG 1-98 trial, are shown to be more effective at reducing recurrence in postmenopausal women than tamoxifen. These drugs have remained an important component of clinical practice.
            </p>
        </>
    );
}

export default AromataseContent;